import { useState } from 'react';
import { AthenaCore } from 'athena-core';
import {
  dispatch,
  OpenModalSchema,
  RedirectSchema,
  ReportPulseSchema,
} from '../../athena-core/src/athena-core-bus';
import { User } from '../types/Auth';

export const useClient = () => {
  const [loading, setLoading] = useState(false);

  const fetchClientsByConsultant = async (adminUserId: string) => {
    console.log('Fetching clients for adminUserId:', adminUserId);
    setLoading(true);
    try {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/api/client/clients-by-consultant?consultantId=${adminUserId}`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await response.json();
      console.log('Response data in fetchClientsByConsultant:', data);

      if (!response.ok) {
        AthenaCore.throwError({
          status: response.status,
          message: data?.message || 'Failed to fetch clients.',
        });
      }

      setLoading(false);
      return data.clients;
    } catch (error: unknown) {
      setLoading(false);
      await dispatch(
        {
          status: 500,
          kind: 'ERROR',
          title: 'Error',
          message:
            error instanceof Error ? error.message : 'Internal Server Error.',
        },
        {
          requireApproval: false,
        }
      );
    }
  };

  return {
    fetchClientsByConsultant,
    loading,
  };
};
